import { SelectedTab } from './types'

export function isNavbarItemAllowed(
  tabKey: SelectedTab,
  allowedNavbarItems: readonly string[] | undefined,
  options?: { requiresExplicitEnablement?: boolean; enabledBy?: SelectedTab }
): boolean {
  if (!allowedNavbarItems) return !options?.requiresExplicitEnablement
  if (allowedNavbarItems.length === 0) return false
  return allowedNavbarItems.includes(options?.enabledBy ?? tabKey)
}
